import React from 'react';
import axios from "../../../../containers/api";
import { Button, Card, CardBody, Row, Label, Input, FormGroup, Badge, Alert, CardTitle } from "reactstrap";
import {Colxx, Separator} from "../../../../components/common/CustomBootstrap";
import { Table } from "../../../../components/table/Table";
import {showCatchError, toEnglishNumbers} from "../../../../helpers/Utils";

class DriverCityNative extends React.Component {
    state = {
        errors: [],
        NationalId: "",
        FreighterCardNumber: "",
        //IsAdmin: (this.props && this.props.IsAdmin)? this.props.IsAdmin:false,
        LoadHallId: (this.props && this.props.LoadHallId) ? this.props.LoadHallId : 0,
        DriverCityNatives: []
    };

    componentDidMount() {
        console.log(this.props.LoadHallId)
        this.GetDriverCityNatives();
    }

    
    GetDriverCityNatives = () => {
        let id = (this.props && this.props.LoadHallId) ? this.props.LoadHallId : 0;
        this.props.showSpinner();
        axios.get('/api/v1/driver-city-natives/GetDriverCityNativeByLoadHallId?LoadHallId=' + id)//this.state.loadHallId
            .then((res) => {
                this.props.hideSpinner();
                this.setState({ DriverCityNatives: res.data.data });
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
            });
    };
     
    reset = () => {
        this.props.closeSweetAlert();
        this.setState({
            errors: [],
            NationalId: "",
            FreighterCardNumber: "",
        });
    };

    validateInputData = () => {
        this.props.closeSweetAlert();
        let error = [];
        if ( this.state.NationalId === null || this.state.NationalId === undefined || this.state.NationalId.trim() === ""  ) {
            error.push("وارد كردن شماره ملی الزامی میباشد.");
        }
        if (this.state.FreighterCardNumber === null || this.state.FreighterCardNumber === undefined || this.state.FreighterCardNumber.trim() === "") {
           
            error.push("وارد كردن هوشمند ناوگان الزامی میباشد.");
        }
        
        this.setState({errors: error});
        if (error.length === 0) {
            
            this.AddDriverCityNative();
            
        } else {
            this.props.showAlert("لطفا تمامی اطلاعات درخواست شده را به درستی وارد کنید!", "error");
        }
    };

    Delete = (Id) => {
        
        this.props.closeSweetAlert();
        this.props.showSpinner();
        axios.delete(`/api/v1/driver-city-natives/DeleteDriverCityNative/${Id}`)
            .then((res) => {
                this.props.hideSpinner();
                this.props.showAlert(res.data.message, 'success')
                 this.GetDriverCityNatives();  
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            })
    };

    AddDriverCityNative = () => {
        let model = {
            
            NationalId: toEnglishNumbers(this.state.NationalId),
            FreighterCardNumber: toEnglishNumbers(this.state.FreighterCardNumber),
            LoadHallId: this.state.LoadHallId
        };

        this.props.showSpinner();
        axios.post('/api/v1/driver-city-natives/AddDriverCityNative', model)
            .then((res) => {
                this.props.hideSpinner();
                if (res.data.data !== null) {
                    this.props.showAlert(res.data.message, "success");
                    this.GetDriverCityNatives();  
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };

    render() {
        return (
            <>
                <Row>
                    <Colxx xxs="12">
                        <h3>افزودن رانندگان ویژه</h3>
                        <Separator className="mb-5" />
                    </Colxx>
                </Row>

                <Row className="mb-3">
                    <Colxx xxs="12">
                        <Card>
                            <CardBody className="d-flex flex-column align-items-center">
                                <div className="d-flex flex-md-row flex-column flex-wrap justify-content-around align-items-center w-100">
                                    <FormGroup className="w-md-25 w-100 mx-1">
                                        <Label>شماره ملی راننده</Label>
                                        <Input value={this.state.NationalId} maxLength={10}
                                               onChange={(e) => this.setState({ NationalId: e.target.value })}/>
                                        
                                    </FormGroup>

                                    <FormGroup className="w-md-25 w-100 mx-1">
                                        <Label>هوشمند ناوگان</Label>
                                        <Input value={this.state.FreighterCardNumber} maxLength={7}
                                            onChange={(e) => this.setState({ FreighterCardNumber: e.target.value })}/>
                                        
                                    </FormGroup>

                                   
                                </div>

                                {this.state.errors.length === 0 ?
                                    null
                                    :
                                    <div>
                                        {(this.state.errors.map((error, i) => {
                                            return (
                                                <Alert color="danger" key={i}>{error}</Alert>
                                            )
                                        }))}
                                    </div>
                                }

                                <div className="mt-4">
                                    <Button className="mx-3 my-md-0 my-1" color="primary"
                                            onClick={() => this.props.showSweetAlert("آیا از ثبت نوبت برای این راننده مطمئن هستید؟", "", "warning", this.validateInputData)}>
                                        ثبت
                                    </Button>
                                    <Button outline color="secondary" className="mx-3 my-md-0 my-1"
                                        onClick={() => this.props.showSweetAlert("", "آیا می‌خواهید تمام اطلاعات واردشده را پاک کنید؟", "danger", this.reset)}>
                                        پاک کردن
                                    </Button>
                                </div>

                                <Separator className="my-5" />

                                <CardTitle>راننده ها</CardTitle>

                                <Table
                                    tableHeaders={[
                                        "شناسه",
                                        "نام  راننده",
                                        "نام خانوادگی راننده",
                                        "کد ملی",
                                        "موبایل",
                                        "شمار هوشمند راننده",
                                        "شماره هوشمند ناوگان",
                                        "حذف",
                                    ]}

                                    tableRow={this.state.DriverCityNatives !== null ? this.state.DriverCityNatives : []}

                                    tableData={[
                                        driver => {
                                            return  driver.id;
                                        },
                                        driver => {
                                            return  driver.driverName;
                                        },
                                        driver => {
                                            return driver.driverFamily;
                                        },
                                        driver => {
                                            return driver.nationalId;
                                        },
                                        driver => {
                                            return driver.mobile;
                                        },
                                        driver => {
                                            return driver.driverCardNumber;
                                        },
                                        driver => {
                                            return driver.freighterNumber;
                                        },
                                        driver => {
                                            return (
                                                <Button outline color="success" size="sm"
                                                    onClick={() => this.Delete(driver.id)}>
                                                    حذف
                                                </Button>
                                            )
                                        }
                                    ]}
                                />
                            </CardBody>
                        </Card>
                    </Colxx>
                </Row>

                 
            </>
        )
    }
}

export default DriverCityNative;